<template>
  <div>
    <h1 class="indigo--text">Aspectos</h1>
    <v-layout wrap>
      <v-flex sm12>
        <v-text-field
          v-model="searchString"
          solo
          label="Buscar Aspectos"
          prepend-inner-icon="mdi-magnify"
          background-color="grey lighten-3"
        ></v-text-field>
      </v-flex>
      <v-flex sm11>
        <v-form ref="form" @submit.prevent="send">
          <v-text-field
            v-model="aspect"
            solo
            label="Agregar nuevo aspecto"
            :rules="requiredRule"
            background-color="grey lighten-3"
          ></v-text-field>
        </v-form>
      </v-flex>
      <v-flex sm1 pt-2 pl-2>
        <v-btn text icon color="grey" type="submit">
          <v-icon large>mdi-plus</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <div v-if="aspects.length > 0">
      <AspectCard
        v-for="(aspect, index) in search"
        :aspect="aspect"
        :key="index"
        @updateAspects="getAspects"
      ></AspectCard>
    </div>
    <div v-else>
      <p>Aún no hay aspectos en la plataforma</p>
    </div>

    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import AspectCard from "@/components/AspectCard";
export default {
  components: {
    AspectCard
  },
  data() {
    return {
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      aspects: [],
      searchString: "",
      aspect: "",
      snackbar: false,
      message: "",
      searchString: "",
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    getAspects() {
      axios
        .get(this.host + "/aspects/read.php")
        .then(response => {
          this.aspects = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    send() {
      if (this.$refs.form.validate()) {
        let data = {
          title: this.aspect,
          idUserVerify: sessionStorage.getItem("authorization")
        };

        axios
          .post(this.host + "/aspects/create.php", this.createFormData(data))
          .then(response => {
            this.aspect = "";
            this.message = response.data.message;
            this.snackbar = true;
            this.getAspects();
            this.$refs.form.resetValidation();
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.getAspects();
  },
  computed: {
    search() {
      return this.aspects.filter(item => {
        return (item.title + "")
          .toLowerCase()
          .includes((this.searchString + "").toLowerCase());
      });
    }
  }
};
</script>